<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">修改预约时间</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">
                <el-form ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-col :span="10" class="item">
                                    <el-form-item label="选择预约时间" required>
                                      <el-date-picker
                                          v-model="planTime"
                                          type="datetime"
                                          style="width:100%;"
                                          value-format="yyyy-MM-dd HH:mm"
                                          placeholder="选择预约时间">
                                      </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm()">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'CartEdit',
        data() {
            return {
                loading: false,

                planTime:'',
              beforeCartBusinessCode:'',

                row:'',
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                        { type: 'number', message: '排序必须为数字值'}
                    ],

                }

            }
        },

        methods: {

            init(row){
                this.planTime=timefilters(row.planTime)
                this.beforeCartBusinessCode=row.beforeCartBusinessCode
            },

            closeSelf() {
                this.$emit("closeEditTime");
            },

            confirm(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AppCare/BeforeCartChangePlanTime",
                    data: {
                      sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                      timeStr:timeStr,
                      staffCode:getStaffCode(),
                      beforeCartBusinessCode:this.beforeCartBusinessCode,
                      planTime:this.planTime,
                    }
                }).then((response) => {
                        if (response.data.error == 0) {
                            this.$emit("closeEditTime");
                            this.$emit("getCart");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    })


            },


        }
    }


</script>
